export const findObjectIndexInArray = (arr, id, keyPropertyName) => {
    if (!arr || !id) return false;
    return arr.map(function (x) { return x[keyPropertyName || 'id']; }).indexOf(id);
}